"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveVideoSchema = void 0;
exports.LiveVideoSchema = {
    "$id": "https://www.redbull.com/schemas/content/live-videos.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "LiveVideo",
    "description": "A live video-stream",
    "properties": {
        "type": {
            "enum": [
                "rrn:content:live-videos"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:live-videos:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        },
        "attributes": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "author": {
                    "type": "string",
                    "deprecated": true,
                    "deprecationReason": "This property will be removed from the abstract with the next release",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "callToActions": {
                    "type": "array",
                    "items": {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/call-to-action.schema.json"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "contentClassificationTerms": {
                    "description": "User defined terms to classify content.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "contextualTitle": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/contextual.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "customProperties": {
                    "description": "Custom properties which can be added to content-resources (E.g. configuration of theme properties, etc.) Note that custom properties are not governed by the content-schema. It is therefore not guaranteed that certain custom properties exist. We also do not migrate custom properties if the schema evolves.",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/key-value.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "geoBlockedIn": {
                    "description": "Countries in which the resource is geo-blocked. Resembled through two-letter ISO_3166-1_alpha-2 country codes",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "isPlaceholder": {
                    "description": "Marks a resource as placeholder.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "legacyContentId": {
                    "description": "RB2 content ID.",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "mainPartner": {
                    "description": "Represents the main partner associated with the resource",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/featured-partners.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "planningClassification": {
                    "description": "Content classification rating from the scheduling team.",
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "A",
                            "B",
                            "C",
                            "D",
                            "E"
                        ]
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "publishedDate": {
                    "description": "The initial published date of the resource. This date is set automatically if the resource is moved from `draft` to `published` state the first time.",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "searchTerms": {
                    "description": "A list of search terms which result in a full-match of a given content resource.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "subHeading": {
                    "description": "An additional title of a resource. e.g. films often have subheadings like `Streif - One Hell of a Ride` where `One Hell of a Ride` would be the subHeading",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "teaser": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "title": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "uriSlug": {
                    "type": "string",
                    "description": "Must be unique across content GUID+language and may be reused for different locales"
                },
                "url": {
                    "description": "If provided, the URL should be used instead of dynamic routes (based on urislug) to link to the content resource (can be used to add resources which are presented outside the RB3 platform)",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/web-link.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "usageRestrictions": {
                    "description": "Restrictions describing where the specific resource should NOT be used.",
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "maturity:NR",
                            "maturity:UR",
                            "no-monetization",
                            "no-stand-alone-display"
                        ]
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "audioStreamLanguages": {
                    "description": "A List of audio stream languages available for the live-video asset. This indicates the languages in which the live video's audio stream can be listened to.",
                    "calculated": true,
                    "type": "array",
                    "items": {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/audio-language.schema.json"
                    }
                },
                "description": {
                    "description": "A list of text blocks containing textual event information. Not all elements may be presented to the user by default. Kepp the first textualAretfactContainer consise (recommended less than 250 chars)",
                    "type": "array",
                    "items": {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
                    }
                },
                "endDate": {
                    "description": "The planned end-date of the stream",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json"
                },
                "isPrimary": {
                    "type": "boolean",
                    "description": "Used to identify which live-stream to highlight if multiple live-streams are available (e.g. for an event) Used for the header section of an live-streamed event-profile (only one can be shown, but multiple streams might be attached to the event-profile) Throughout the life of an live-streamed event, the primary live stream may change multiple times.",
                    "deprecated": true,
                    "deprecationReason": "This flag is deprecated in favor of relations on event-profiles"
                },
                "liveStreamPartners": {
                    "description": "The streams that are exclusively available on our partners' platforms. Streaming partnerships are specified by country, and time bound. Once the stream has ended, it can be viewed on our owned platforms after a contractually defined time period.",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/partner-streams.schema.json"
                },
                "startDate": {
                    "description": "The start date/time of the livestream",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json"
                },
                "status": {
                    "type": "string",
                    "description": "The status of the live-stream",
                    "enum": [
                        "canceled",
                        "delayed",
                        "live",
                        "pre",
                        "post",
                        "trim",
                        "unconfirmed"
                    ]
                },
                "statusLabel": {
                    "type": "string",
                    "description": "An editorially set status label which should be used instead of the status enum if set. Used e.g. to indicate that a stream is `broadcasted` (fake-live)."
                },
                "statusMessage": {
                    "type": "string",
                    "description": "An editorially set status message for the status of the live stream (e.g. `waiting for the swell` or `delayed due to weather conditions`)"
                },
                "videoDurationSeconds": {
                    "type": "integer",
                    "description": "Duration of the live video stream if the stream is already over."
                },
                "videoEssence": {
                    "description": "Reference to an asset in the media asset management system (e.g. Mediabase RBMN API)",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/type-groups/services/video/live.schema.json"
                },
                "videoFrameAspectRatio": {
                    "type": "number",
                    "description": "Aspect ratio of the video-frame (width / height)"
                },
                "isEuropeanWork": {
                    "type": "boolean",
                    "description": "Live-Video is a European Work according to the following guideline: https://digital-strategy.ec.europa.eu/en/policies/european-works - information patched by rbmn service"
                },
                "contextualDescription": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/contextual.schema.json",
                    "description": "Context-specific variations of the description, tailored to meet the requirements of different use cases (e.g., EPG descriptions customized for syndication partners or other distribution channels)."
                }
            },
            "required": [
                "title",
                "uriSlug",
                "videoEssence"
            ]
        },
        "relationships": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "contentCollections": {
                    "type": "object",
                    "description": "Lists all content-collections that are automatically assigned through the tag tree. Collections are automatically assigned if the `autoAssign` attribute of the collection is set to `true` and one of the tags set on the content resource is also available on the content collection's `mappedTags` relationship.",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/collections.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "displayTags": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "deprecated": true,
                    "deprecationReason": "Display-tags are replaced with content-collections. Use relationship `contentCollections` instead. For further details check out http://bit.ly/2F9w93H",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/tags.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "embeddedResources": {
                    "type": "object",
                    "description": "All resources embedded in attributes",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "featuredMedia": {
                    "type": "object",
                    "description": "Content element (usually images) used for featuring of a content element",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                                    },
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/preview-clips.schema.json"
                                    },
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                                    }
                                ]
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "headerMedia": {
                    "type": "object",
                    "description": "Content piece shown in the header of another content element (e.g. image shown in the header of a story)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "anyOf": [
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/episode-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/films.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/recap-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/trailer-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/video-channels.schema.json"
                                }
                            ]
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "locations": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/locations.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "logo": {
                    "type": "object",
                    "description": "Optional logo for a content piece (e.g. logo for an event-profile)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "master": {
                    "type": "object",
                    "description": "Reference to the master resource holding all translations",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "partners": {
                    "type": "object",
                    "description": "Contains a list of additional partners or sponsors associated with the resource",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "pseudoGroups": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/tags.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "relatedContents": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "socialMediaImage": {
                    "type": "object",
                    "description": "Image that represents a content resource on social media platforms (og:image)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "tags": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "translatedFrom": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "translations": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "events": {
                    "type": "object",
                    "description": "All events in which this live-stream is referenced through the live relationship.",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/event-profiles.schema.json"
                            }
                        }
                    }
                }
            }
        },
        "links": {
            "type": "object",
            "additionalProperties": {
                "type": [
                    "object",
                    "string"
                ],
                "description": "A link **MUST** be represented as either: a string containing the link's URL or a link object.",
                "oneOf": [
                    {
                        "description": "A string containing the link's URL.",
                        "type": "string",
                        "format": "uri-reference"
                    },
                    {
                        "type": "object",
                        "required": [
                            "href"
                        ],
                        "properties": {
                            "href": {
                                "description": "A string containing the link's URL.",
                                "type": "string",
                                "format": "uri-reference"
                            },
                            "meta": {
                                "description": "Non-standard meta-information that can not be represented as an attribute or relationship.",
                                "type": "object",
                                "additionalProperties": true
                            }
                        }
                    }
                ]
            }
        },
        "meta": {
            "additionalProperties": true,
            "type": "object",
            "properties": {
                "createdBy": {
                    "description": "User or system that initially created a resource",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "dateCreated": {
                    "description": "DateTime when a resource was created",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "dateUpdated": {
                    "description": "DateTime when a resource was last changed. Every change to a resource results in a new dateUpdated",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "externalReference": {
                    "description": "Reference to external applications (e.g. if the asset was imported)",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/external-reference.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "foreignKeys": {
                    "description": "Foreign keys of this asset in other systems (e.g. if the asset was imported / links to media asset system)",
                    "type": "array",
                    "deprecated": true,
                    "deprecationReason": "This property will be removed anytime soon. However, the information won't be lost but migrated to `externalReference`",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "language": {
                    "description": "The language the resource is written in",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "locale": {
                    "description": "The locale of the resource.",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "machineTranslated": {
                    "description": "Indicates if the asset was translated by machine/AI.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "published": {
                    "description": "Indicator if resource is published.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "region": {
                    "description": "The region or country the resource was published for (e.g. INT for international region, AT for Austria)",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "spaces": {
                    "description": "Content-spaces a resource is assigned to",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "status": {
                    "description": "Represents the current lifecycle state of the resource. The status can either be `DRAFT`, `PUBLISHED`, or `UNPUBLISHED`.",
                    "type": "string",
                    "enum": [
                        "DRAFT",
                        "PUBLISHED",
                        "UNPUBLISHED"
                    ],
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "updatedBy": {
                    "description": "User or system that updated the resource the last time",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                }
            }
        }
    },
    "type": "object",
    "required": [
        "type",
        "id",
        "attributes",
        "relationships"
    ]
};
//# sourceMappingURL=data:application/json;base64,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